import { css } from 'styled-components';
export const inViewMargin = '0px 0px -35% 0px';
export const rootMargin = '0px 0px -20% 0px';
export const cubicEaseOut = `cubic-bezier(0.33, 1, 0.68, 1)`;
export const shouldAnimate = (innerCss) => {
    return css `
    @media (prefers-reduced-motion: no-preference) {
      ${innerCss}
    }
  `;
};
export const transition = (properties, duration = 0.35, timing = cubicEaseOut) => {
    return shouldAnimate(css `
    transition-duration: ${typeof duration === 'string' ? duration : `${duration}s`};
    transition-property: ${properties};
    transition-timing-function: ${timing};
    will-change: ${properties};
  `);
};
export function inViewFade(params) {
    return css `
    transition: opacity;
    transition-delay: ${params.delay}s;
    transition-duration: ${params.duration}s;
    transition-timing-function: ${cubicEaseOut};

    [data-inview='false'] & {
      opacity: 0;
    }

    [data-inview='true'] & {
      opacity: 1;
    }
  `;
}
export function inViewFadeUp(params) {
    return css `
    transition: opacity, transform;
    transition-delay: ${params.delay}s;
    transition-duration: ${params.duration}s;
    transition-timing-function: ${cubicEaseOut};

    [data-inview='false'] & {
      opacity: 0;
      transform: translateY(20px);
    }

    [data-inview='true'] & {
      opacity: 1;
      transform: translateY(0);
    }
  `;
}
